import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
  TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const dailyCropData = this.props.dailyCropData;
    const total = this.props.total;
    const searchData = this.props.searchData;
    const dailyCropDetail = this.props.dailyCropDetail;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <div>
          <h3><center><u>Daily Crop Report</u></center></h3>
          <h4><center>{searchData.groupName} -  {searchData.factoryName}</center></h4>
          <h4><center>{searchData.routeName === undefined ? 'All Routes' : searchData.routeName }</center></h4>
          <h4><center>{dailyCropDetail .registrationNumber === '' ? 'All Registration Numbers' : 'Reg No : ' + dailyCropDetail .registrationNumber }</center></h4>
          <h4><center>{dailyCropDetail.date}</center></h4>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050} style={{paddingLeft:"10px", paddingRight:"10px"}}>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{ border: '1px solid black' }}>
                      <TableCell align={'left'} style={cellStyle}>Route Name</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Reg No</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Supplier Name</TableCell>
                      <TableCell align={'left'} style={cellStyle}>Leaf Type</TableCell>
                      <TableCell align={'right'} style={cellStyle}>Net Amount (KG)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dailyCropData.map((data, index) => (
                      <TableRow key={index} style={{ border: '1px solid black' }}>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.routeName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.name}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                          {data.collectionTypeName}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={cellStyle}>
                          {data.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow style={{ border: '1px solid black' }}>
                    <TableCell align={'left'} style={cellStyle}><b>Total</b></TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={cellStyle}>
                      <b> {total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div></div>
    );
  }
}
